import { trackEvent } from '@/lib/datadog';

const MFE_RESOURCE_PATTERN = /mf-manifest\.json|remoteEntry|\/nsapps?\//;
const LONG_TASK_THRESHOLD_MS = 50;

function stripQueryAndHash(url: string): string {
  try {
    const parsed = new URL(url);
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    return url.split('?')[0].split('#')[0];
  }
}

function observeMfeResourceTiming(): void {
  const observer = new PerformanceObserver(list => {
    for (const entry of list.getEntries() as PerformanceResourceTiming[]) {
      if (!MFE_RESOURCE_PATTERN.test(entry.name)) continue;

      trackEvent('mfe_resource', {
        category: 'mfe_resource',
        url: stripQueryAndHash(entry.name),
        duration: entry.duration,
        ttfb: entry.responseStart - entry.requestStart,
        transfer_size: entry.transferSize,
        cache_hit: entry.transferSize === 0 && entry.decodedBodySize > 0,
        protocol: entry.nextHopProtocol,
      });
    }
  });

  observer.observe({ type: 'resource', buffered: true });
}

function observeLongTasks(): void {
  const observer = new PerformanceObserver(list => {
    for (const task of list.getEntries()) {
      if (task.duration <= LONG_TASK_THRESHOLD_MS) continue;

      trackEvent('long_task', {
        category: 'long_task',
        duration: task.duration,
        route: globalThis.location.pathname,
      });
    }
  });

  observer.observe({ type: 'longtask', buffered: true });
}

export function initPerfObservers(): void {
  if (typeof PerformanceObserver === 'undefined') return;

  const supportedEntryTypes = PerformanceObserver.supportedEntryTypes ?? [];

  if (supportedEntryTypes.includes('resource')) {
    observeMfeResourceTiming();
  }

  if (supportedEntryTypes.includes('longtask')) {
    observeLongTasks();
  }
}
